// @react/hooks/useBillingPrice.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingPriceStore } from '@core/stores';

/**
 * React hook for Price operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingPrice } from '@react/hooks';
 *
 * const PriceList = observer(() => {
 *   const store = useBillingPrice();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingPrice() {
  return billingPriceStore;
}
